export const SECTION_CONTAINER_VARIANT_NORMAL = 'normal';
export const SECTION_CONTAINER_VARIANT_CONTENT_OVERFLOWED = 'contentOverflowed';

export const SECTION_CONTENT_WIDTH_NORMAL = 'normal';
export const SECTION_CONTENT_WIDTH_FULL = 'full';
